import React, { useCallback, useContext, useEffect } from 'react';
import { VideoContext } from '../contexts/VideoContext';
import TopBar from './TopBar';
import VideoBrowser from './VideoBrowser';
import LoadingSpinner from './common/LoadingSpinner';
import Uploader from './Uploader';
import { SystemContext } from '../contexts/SystemContext';
import MODES from '../types/Modes';
import Sanity from '../services/Sanity';
var Dashboard = function () {
    var loading = useContext(VideoContext).loading;
    var mode = useContext(SystemContext).mode;
    var loadVideos = useCallback(function () {
        Sanity.paginator.getVideos();
    }, []);
    useEffect(function () {
        loadVideos();
    }, [loadVideos]);
    return (React.createElement("div", { className: "w-screen h-screen bg-gray-800 text-white" },
        React.createElement("div", { className: "m-auto p-2 max-w-7xl" },
            React.createElement(TopBar, null),
            loading ? React.createElement(LoadingSpinner, null) :
                mode === MODES.BROWSING ?
                    React.createElement("div", null,
                        React.createElement(VideoBrowser, null))
                    : React.createElement(Uploader, null))));
};
export default Dashboard;
